module.exports = __webpack_public_path__ + "static/img/4618_phase_function_Paper_PointsHejduk_Prediction.f329d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4618_phase_function_Paper_PointsHejduk_Prediction.png
// module id = EqLa
// module chunks = 0